import Vue from "vue";
import textTruncateDirective from "@/modules/common/directives/textTruncate/TextTruncate.directive";
Vue.directive("textTruncate", textTruncateDirective);
